import { cloneDeep } from "lodash";

const subtitles = [
  "Test your English proficiency by interacting with AI officers.",
  "Talk to an AI designed to perform a DOT inspection.",
  "Practice for realistic DOT inspection scenarios.",
];

const introduction = [
  {
    type: "text/main_title_subtitle",

    verticalAlign: "center",
    horizontalAlign: "center",

    titles: ["Practice Stop"],
    subtitles,
    textStyle: {
      textAlign: "center",
    },
  },
];

const introduction_showcase = [
  {
    type: "screenshot/showcase_double_pivot",


    screenshots: [
      {
        src: "practice-stop/assets/screenshots/inspection_page.png",
        alt: "Screenshot if inspection page",
      },
      {
        src: "practice-stop/assets/screenshots/feedback_page.png",
        alt: "Screenshot of past inspections",
      },
    ],
  },
];

const main_feature_descriptions = [
  {
    type: "layout/split_horizontal",
    contentLeft: [
      {
        type: "screenshot/single_enlarged",

        horizontalAlign: "start",

        screenshots: [{
          src: "practice-stop/assets/screenshots/conversations_page.png",
          alt: "Screenshot of feedback from inspection",
        }],
      },
    ],
    contentRight: [
      {
        type: "text/title_subtitle",

        horizontalAlign: "start",

        titles: ["AI Mock Inspections"],
        subtitles: [
          "Talk to an AI whose purpose is to perform a DOT inspection and learn the questions that are typically asked.",
        ],
      },
      {
        type: "text/title_subtitle",

        horizontalAlign: "start",

        titles: ["English Conversation Practice"],
        subtitles: [
          "Practice your English conversation skills with voice interactions.",
        ],
      },
    ],
  },
];

const shared_feature_descriptions = [
  {
    type: "layout/split_horizontal",
    contentRight: [
      {
        type: "screenshot/single_enlarged",

        horizontalAlign: "start",
        screenshotSide: "right",

        screenshots: [{
          src: "practice-stop/assets/screenshots/home_page.png",
          alt: "Screenshot of difficulty level selection",
        }],
      },
    ],
    contentLeft: [
      {
        type: "text/title_subtitle",

        textStyle: {
          textAlign: "end",
        },

        titles: ["Realistic Scenarios"],
        subtitles: [
          "Practice with realistic DOT inspection scenarios and document presentation.",
        ],
      },
      {
        type: "text/title_subtitle",

        textStyle: {
          textAlign: "end",
        },

        titles: ["Track Your Progress"],
        subtitles: [
          "Engage in 10-minute timed sessions and track your session history to see your improvement.",
        ],
      },
    ],
  },
]


const mobile_main_feature_descriptions = cloneDeep(main_feature_descriptions);
mobile_main_feature_descriptions[0].contentLeft[0].containerStyle = {
  justifyContent: "end",
};

const mobile_shared_feature_descriptions = cloneDeep(shared_feature_descriptions);
mobile_shared_feature_descriptions[0].contentRight[0].containerStyle = {
  justifyContent: "start",
};

export const practice_stop_config = {
  name: "Practice Stop",
  subtitles,
  backgroundColor: "#1dd3b0",

  //Vanta
  highlightColor: "#00FFCC",
  midtoneColor: "#FF82E0",
  lowlightColor: "#36827F",
  baseColor: "#1DD3B0",

  path: "/practice-stop",

  title: "Practice Stop: DOT Inspections",
  description:
    "Practice Stop allows CDL holders to learn how to interact with DOT inspectors so that they are ready. Get your English skills up with accurate feedback on problem areas, practice responses and English comprehension of actions.",
  keywords:
    "DOT Inspection Practice, CDL traffic stop, English proficiency for truck drivers, new FMCSA regulations, document presentation practice",

  googlePlayLink: "https://play.google.com/store/apps/details?id=com.myfortuna.practice_stop",
  appStoreLink: "https://apps.apple.com/us/app/practice-stop-dot-inspections/id6747646817",

  sections: [
    {
      type: "layout/split_horizontal",
      leftFlex: 4,
      rightFlex: 6,
      contentLeft: [...introduction],
      contentRight: [...introduction_showcase],
    },
    ...main_feature_descriptions,
    ...shared_feature_descriptions,
  ],
  mobileSections: [
    ...introduction,
    ...introduction_showcase,
    ...mobile_main_feature_descriptions,
    ...mobile_shared_feature_descriptions,
  ],
}; 